import { useEffect, useState, useCallback, useRef } from "react";

// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";
// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import {
  dietChartSelector,
  clearClientState,
  clearState,
} from "store/features/dietchart";

import { toast } from "react-toastify";

import { userSelector } from "store/features/authSlice";
import ChartTable from "./sub-components/ChartTable";
import PaymentModal from "./sub-components/modal/payment";
import DietModal from "./sub-components/modal/diet";

import Card from "@mui/material/Card";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import Button from "@mui/material/Button";
import NoData from "containers/DataNotAvailBox";
import { TailSpin } from "react-loader-spinner";
import DeleteModal from "containers/DeleteModal";
import Createable from "containers/Select";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import {
  getClientList,
  getClient,
  RemoveDiet,
  getClientDietChart,
} from "services/dietchart";
import CustomButton from "containers/CustomButton";
import { CLIENT_NOT_FOUND } from "constant";
import { useLocation } from "react-router-dom";
import { getClientKey } from "services/dietchart";
import DietPlannerIndex from "./sub-components/modal/newDiet";
import PlanDetails from "./sub-components/PlanDeit/PlanDetails";
import DietHeaderInfo from "./sub-components/modal/newDiet/DietHeaderInfo";
import { getClientDetails } from "store/features/clientDetails";
import { clientDetailsSelector } from "store/features/clientDetails";
import ViewClientDetails from "./sub-components/modal/newDiet/ViewClientDetails";
import { fetchSchedules } from "store/features/dietchart";
import { checkActiveService } from "utils/common";
import { LAYOUT_VARIANT_PER_DAY } from "utils/perDayDietChart";
import WeeklyPerDayFlow from "./sub-components/weeklyPerDay/WeeklyPerDayFlow";
import AddDietPlanChoiceDialog from "./sub-components/AddDietPlanChoiceDialog";

function DietChart() {
  const { uid, dietChartSettings, dietChartTemplates } =
    useSelector(userSelector);
  const { clientDetailsData } = useSelector(clientDetailsSelector);
  const navigate = useNavigate();
  const { isError, isSuccess, message, isFetching, schedules } =
    useSelector(dietChartSelector);

  const dispatch = useDispatch();
  const isFirstLoad = useRef(true);

  const [searchParams, setSearchParams] = useSearchParams();
  const page = searchParams.get("page");

  const [deleteModal, setDeleteModal] = useState(false);
  const [newPaymentModal, setNewPaymentModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [newDietModal, setNewDietModal] = useState(false);
  const [newScheduleModal, setNewScheduleModal] = useState(false);
  const [clients, setClients] = useState([]);
  const [clientLoader, setClientLoader] = useState(false);
  const [formData, setFormData] = useState();
  const [isClientDetails, setIsClientDetails] = useState(false);
  const [dietPlan, setDietPlan] = useState({});
  /** Controls the “Add New Diet Plan” choice dialog (weekly grid vs day-by-day). */
  const [addPlanChoiceOpen, setAddPlanChoiceOpen] = useState(false);


  //diet chart of client
  const [dietchart, setDietChart] = useState([]);
  const getClientListHandler = useCallback(async () => {
    try {
      setClientLoader(true);
      const data = await getClientList(uid);
      setClientLoader(false);
      setClients(data);
    } catch (err) {
      setClientLoader(false);
      toast.error("Something went wrong!!");
    }
  }, [uid]);

  useEffect(() => {
    getClientListHandler();
  }, [getClientListHandler]);

  useEffect(() => {
    if (isFirstLoad.current) {
      const navType =
        window.performance.getEntriesByType("navigation")[0]?.type;
      if (navType === "reload" && page === "make_diet_plan") {
        setSearchParams({ page: "select_plan_details" });
      }
      if (navType === "reload" && page === "weekly_per_day_plan") {
        setSearchParams({});
      }
      isFirstLoad.current = false;
    }
  }, [page, setSearchParams]);

  const addHandler = async () => {
    setSelectedClientv1(null);
    setMode("create");
    if (dietChartSettings.dietChartCreationLayoutType === "Old") {
      setNewDietModal(true);
      setEditValue(false);
    } else {
      setSearchParams({ page: "select_plan_details" });
    }
  };

  const addWeeklyPerDayHandler = () => {
    setSelectedItem(null);
    setMode("create");
    setEditValue(false);
    setSearchParams({ page: "weekly_per_day_plan" });
  };

  const closeAddPlanChoice = () => setAddPlanChoiceOpen(false);

  const handleDayByDayFromChoice = () => {
    closeAddPlanChoice();
    void addHandler();
  };

  const handleWeeklyGridFromChoice = () => {
    closeAddPlanChoice();
    addWeeklyPerDayHandler();
  };

  const editHandler = async (item, type) => {
    setMode("edit");
    setSelectedItem(item);
    if (type === "payment") {
      return setNewPaymentModal(true);
    }
    if (item.layoutVariant === LAYOUT_VARIANT_PER_DAY) {
      setSearchParams({ page: "weekly_per_day_plan" });
      return;
    }
    setNewDietModal(true);
  };

  //delete handler
  const [deleteLoader, setDeleteLoader] = useState(false);
  const deleteHandler = async (id) => {
    try {
      setDeleteLoader(true);
      await RemoveDiet(id);

      setDietChart((e) => {
        e = e.filter((item) => {
          if (item.dietChartId !== id) {
            return item;
          }
          return null;
        });
        return [...e];
      });
      toast.success("Successfully deleted!!!");
      setDeleteModal(false);
      setSelectedItem(null);
      setDeleteLoader(false);
    } catch (e) {
      setDeleteLoader(false);
      toast.error(e.message);
    }
  };

  const [selectedClientv1, setSelectedClientv1] = useState();
  //use for search with unique code field
  const [client, setClient] = useState(null);
  const [getClientLoader, setGetClientLoader] = useState(false);

  const [isServiceActive, setIsServiceActive] = useState(false);
  const [clientActive, setClientActive] = useState();

  const getSelectedClient = useCallback(async () => {
    try {
      if (selectedClientv1) {
        setGetClientLoader(true);
        const [clientResult, dietChartResult] = await Promise.allSettled([
          getClient(selectedClientv1.value),
          getClientDietChart(selectedClientv1.value),
        ]);
        const data =
          clientResult.status === "fulfilled"
            ? clientResult.value
            : CLIENT_NOT_FOUND;
        const dietchart_ =
          dietChartResult.status === "fulfilled" ? dietChartResult.value : [];

        if (dietChartResult.status === "fulfilled") {
          setDietChart(dietchart_);
        } else {
          console.log("Error fetching diet chart:", dietChartResult.reason);
        }
        if (data === CLIENT_NOT_FOUND) {
          if (dietchart_ && dietchart_.length > 0) {
            setClient({
              id: selectedClientv1.value,
              name: selectedClientv1.label || selectedClientv1.name || "",
            });
          } else {
            toast.info("Client not found!!!");
            setClient(null);
          }
        } else {
          setClient(data);
        }
        setGetClientLoader(false);
      } else {
        setGetClientLoader(false);
        setClient(null);
      }
    } catch (e) {
      setGetClientLoader(false);
      setClient(null);
      console.log(e);
      toast.info("Something went wrong!!!");
    }
  }, [selectedClientv1]);

  useEffect(() => {
    if (uid) {
      dispatch(fetchSchedules(uid));
    }
  }, [uid]);

  useEffect(() => {
    if (selectedClientv1) {
      getSelectedClient();
    } else {
      setGetClientLoader(false);
      setClient(null);
    }
  }, [getSelectedClient, selectedClientv1]);

  useEffect(() => {
    if (clientActive) {
      const getSelectedClientDetails = async () => {
        const data = await getClient(clientActive.clientName.value);
        checkActiveService(data, setIsServiceActive);
      };

      getSelectedClientDetails();
    }
  }, [getSelectedClient, clientActive, selectedItem]);

  const resetHandler = () => {
    dispatch(clearClientState());
    setFormData();
    setDietChart([]);
    setIsServiceActive(false);
  };

  const [editValue, setEditValue] = useState(true);

  useEffect(() => {
    if (formData?.clientName) {
      dispatch(getClientDetails({ id: formData.clientName.key }));
    }
  }, [formData?.clientName]);

  useEffect(() => {
    if (isSuccess) {
      toast.success(message);

      if (selectedItem) {
        getSelectedClient();
      }
      dispatch(clearState());
    }
    if (isError) {
      toast.error(message);
      dispatch(clearState());
    }
  }, [
    isSuccess,
    message,
    dispatch,
    isError,
    isFetching,
    selectedItem,
    getSelectedClient,
  ]);

  const location = useLocation();

  const fetchClientKey = useCallback(async (id) => {
    let data = await getClientKey({ id });
    setSelectedClientv1(data);
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id");

    if (id) {
      fetchClientKey(id);
    }
  }, [location, fetchClientKey]);

  const [mode, setMode] = useState("view");
  const viewHandler = useCallback(async (item, type) => {
    setMode("view");
    setSelectedItem(item);
    if (
      type === "diet" &&
      item.layoutVariant === LAYOUT_VARIANT_PER_DAY
    ) {
      setSearchParams({ page: "weekly_per_day_plan" });
      return;
    }
    switch (type) {
      case "diet":
        setNewDietModal(true);
        break;
      case "payment":
        setNewPaymentModal(true);
        break;
      default:
        break;
    }
  }, [setSearchParams]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {page && (
        <Card sx={{ marginBottom: 1, borderRadius: "10px" }}>
          <SuiBox
            px={3}
            py={0.5}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <SuiButton
              component={Button}
              color="dark"
              variant="gradient"
              onClick={() => navigate(-1)}
              sx={{
                px: 2,
                textTransform: "none",
                fontWeight: 500,
                borderRadius: "6px",
              }}
            >
              <ArrowBackIcon style={{ fontSize: 16, marginRight: 8 }} />
              Back
            </SuiButton>

            <DietHeaderInfo
              formData={formData}
              setIsClientDetails={setIsClientDetails}
            />
          </SuiBox>
        </Card>
      )}

      {!page && (
        <Card style={{ minHeight: "28vh", overflow: "inherit" }}>
          <SuiBox
            display="flex"
            justifyContent="space-between"
            flexWrap="wrap"
            alignItems="center"
            p={3}
            pb={1}
          >
            <SuiTypography display="flex" alignItems="center">
              <SuiTypography variant="h6" ml={1}>
                {"Diet Chart List"}
              </SuiTypography>
              <span
                style={{
                  paddingLeft: "6px",
                  fontSize: "14px",
                  height: "16px",
                  width: "14px",
                }}
              >
                <Tooltip
                  title={
                    "Choose your existing clients from the list below and view diet chart."
                  }
                  placement="top"
                  style={{ color: "#67748e", height: "16px", width: "14px" }}
                >
                  <Icon color="inherit">{"help"}</Icon>
                </Tooltip>
              </span>
            </SuiTypography>
            <SuiBox
              className="search-box-div"
              style={{
                width: "80%",
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                justifyContent: "flex-end",
                gap: 10,
              }}
            >
              <CustomButton
                color="dark"
                variant="gradient"
                onClick={() => setAddPlanChoiceOpen(true)}
                width={180}
                style={{
                  marginBottom: 10,
                  height: 40,
                  width: 230,
                  padding: 10,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                title={"Add New Diet Plan"}
              />
            </SuiBox>
          </SuiBox>
          <SuiTypography
            variant="button"
            fontWeight="regular"
            color={"dark"}
            sx={{ ml: 3.5, mb: 2 }}
          >
            Choose a client from the dropdown below to view their Diet Chart.
          </SuiTypography>

          <SuiBox
            px={3}
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Createable
              options={clients}
              loading={clientLoader}
              value={selectedClientv1}
              style={{ borderRadius: "0.5rem", fontSize: 14 }}
              inputStyle={{
                width: 220,
                height: "1.800rem",
                borderRadius: "0.5rem",
              }}
              placeholder="Choose client"
              onChange={(e) => {
                setClient(null);
                setSelectedClientv1(e);
                setClientActive({
                  clientName: e,
                });
              }}
            />

            <SuiButton
              component={Button}
              color="dark"
              variant="outlined"
              onClick={() => {
                resetHandler();
                setSelectedClientv1(null);
              }}
            >
              Reset
            </SuiButton>
          </SuiBox>

          {client !== null && selectedClientv1 ? (
            <ChartTable
              viewHandler={viewHandler}
              setMode={setMode}
              newPaymentModal={newPaymentModal}
              dietchart={dietchart}
              dispatch={dispatch}
              dietChartArray={dietchart ?? []}
              selectedClient={client}
              setSelectedItem={setSelectedItem}
              setNewPaymentModal={setNewPaymentModal}
              editHandler={editHandler}
              isSuccess={isSuccess}
              deleteHandler={(id, name) => {
                setSelectedItem({ id, name });
                setDeleteModal(true);
              }}
              uid={uid}
            />
          ) : getClientLoader ? (
            <SuiBox
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginBottom: 30,
              }}
            >
              <TailSpin color="#17c1e8" height={60} width={60} />
            </SuiBox>
          ) : (
            <SuiBox style={{ marginTop: 35 }}>
              <NoData />
            </SuiBox>
          )}
        </Card>
      )}
      <AddDietPlanChoiceDialog
        isDialogOpen={addPlanChoiceOpen}
        onCloseDialog={closeAddPlanChoice}
        onSelectDayByDay={handleDayByDayFromChoice}
        onSelectWeeklyGrid={handleWeeklyGridFromChoice}
      />
      <PaymentModal
        open={newPaymentModal}
        mode={mode}
        setOpenModal={setNewPaymentModal}
        isSuccess={isSuccess}
        isError={isError}
        isFetching={isFetching}
        message={message}
        id={client?.id}
        uid={uid}
        services={client?.services ?? []}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        handleCloseModal={() => {
          setTimeout(() => {
            if (selectedItem) {
              setSelectedItem(null);
            }
          }, 500);
          setNewPaymentModal(false);
        }}
        viewHandler={viewHandler}
        editHandler={editHandler}
      />

      <DietModal
        open={newDietModal}
        mode={mode}
        setOpenModal={setNewDietModal}
        setDietChart={setDietChart}
        id={uid}
        clients={clients}
        editValue={editValue}
        client={client}
        setSelectedClientv1={setSelectedClientv1}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        handleCloseModal={() => {
          setEditValue(true);
          setNewDietModal(false);
        }}
        viewHandler={viewHandler}
        editHandler={editHandler}
        isServiceActive={isServiceActive}
        setClientActive={setClientActive}
      />

      {deleteModal && (
        <DeleteModal
          isFetching={deleteLoader}
          onDeleteHandler={deleteHandler}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          deleteModal={deleteModal}
          setDeleteModal={setDeleteModal}
        />
      )}

      {page === "select_plan_details" && (
        <PlanDetails
          setSearchParams={setSearchParams}
          searchParams={searchParams}
          open={newDietModal}
          mode={mode}
          setMode={setMode}
          setOpenModal={setNewDietModal}
          setDietChart={setDietChart}
          id={uid}
          clients={clients}
          editValue={editValue}
          client={client}
          setSelectedClientv1={setSelectedClientv1}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          handleCloseModal={() => {
            setEditValue(true);
            setNewDietModal(false);
          }}
          viewHandler={viewHandler}
          editHandler={editHandler}
          formData={formData}
          setFormData={setFormData}
          dietChartTemplates={dietChartTemplates}
          setDietPlan={setDietPlan}
          schedules={schedules}
          selectedClientv1={selectedClientv1}
          isServiceActive={isServiceActive}
          setClientActive={setClientActive}
        />
      )}

      {page === "weekly_per_day_plan" && (
        <WeeklyPerDayFlow
          uid={uid}
          clients={clients}
          client={client}
          selectedClientv1={selectedClientv1}
          mode={mode}
          setMode={setMode}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          dietchart={dietchart}
          setDietChart={setDietChart}
          schedules={schedules}
          setFormData={setFormData}
        />
      )}

      {page === "make_diet_plan" && (
        <DietPlannerIndex
          open={newScheduleModal}
          clients={clients}
          onClose={() => setNewScheduleModal(false)}
          uid={uid}
          setMode={setMode}
          mode={mode}
          setSelectedItem={setSelectedItem}
          selectedItem={selectedItem}
          dietchart={dietchart}
          setDietChart={setDietChart}
          setSelectedClientv1={setSelectedClientv1}
          formData={formData}
          setFormData={setFormData}
          setSearchParams={setSearchParams}
          searchParams={searchParams}
          dietPlan={dietPlan}
          setDietPlan={setDietPlan}
          schedules={schedules}
          clientDetailsData={clientDetailsData}
        />
      )}

      {isClientDetails && (
        <ViewClientDetails
          open={isClientDetails}
          setIsClientDetails={setIsClientDetails}
          clientDetailsData={clientDetailsData}
        />
      )}
    </DashboardLayout>
  );
}

export default DietChart;
